
import React from 'react';
import { useFormContext } from "react-hook-form";
import { Label } from '@/components/ui/label';
import { Input } from '@/components/ui/input';
import { HomeIcon } from 'lucide-react';

interface TotalDisplayProps {
  label: string;
  fieldName: string;
  value: string;
  readOnly?: boolean;
}

const TotalDisplay = ({ label, fieldName, value, readOnly = false }: TotalDisplayProps) => {
  const { register } = useFormContext();
  
  return (
    <div className="form-group">
      <Label className="form-label flex items-center gap-2">
        <HomeIcon size={16} />
        {label}
      </Label>
      <Input 
        {...register(fieldName)}
        value={value}
        className="form-input bg-gray-100"
        disabled={true} // Total displays are always disabled
      />
    </div>
  );
};

export default TotalDisplay;
